import { DatePivotParams } from "../../entities/date_pivot_params";

// The Display-by control names its options from the dataset schema, so normally it
// emits the real column names and this map is an identity. It only earns its keep
// when the schema is unavailable (a run whose parquet is missing): the control then
// falls back to using the captions, and without this the week button would silently
// serve month data.
const DATE_FIELD_BY_HIERARCHY: Record<string, string> = {
  month: "order_delivery_month",
  week: "order_delivery_week",
  order_delivery_month: "order_delivery_month",
  order_delivery_week: "order_delivery_week",
};

export const paramsToTransformArgs = (
  params: DatePivotParams
): Record<
  string,
  string | string[] | Date | [string, string, string[] | string][] | null
> => {
  return {
    date_field:
      DATE_FIELD_BY_HIERARCHY[params.dateHierarchy] ?? "order_delivery_month",
    min_date: params.minDate ?? null,
    max_date: params.maxDate ?? null,
    segmentation_fields: params.segments ?? [],
    filters: params.filters,
    post_filters: params.postFilters ?? [],
  };
};
